import { SeriesItemData } from '../../cards/series-item-card/SeriesItemCardProps';

export const SAVED_CHANGED_EVENT = 'blkAcSavedStateChanged';
export const SAVED_FETCHED_EVENT = 'blkAcSavedStateFetched';

export type SavedChangedEventDetail = {
	saveUrl: string;
	newState: boolean;
	sourceComponentId: string;
};
export type SavedFetchedEventDetail = SavedChangedEventDetail & {
	item: SeriesItemData | undefined;
};

export type SavedChangedEvent = CustomEvent<SavedChangedEventDetail>;
export type SavedFetchedEvent = CustomEvent<SavedFetchedEventDetail>;

export type SavedChangeEventHandler = (
	eventDetail: SavedChangedEventDetail
) => void;
export type SavedFetchedEventHandler = (
	eventDetail: SavedFetchedEventDetail
) => void;

export const addSavedChangeListener = (
	savedChangeEventHandler: SavedChangeEventHandler
): (() => void) => {
	const selfWindowHandler = (event: SavedChangedEvent) => {
		savedChangeEventHandler(event.detail);
	};
	const storageHandler = (event: StorageEvent) => {
		if (event.key === SAVED_CHANGED_EVENT) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			const newValue = JSON.parse(event.newValue) as SavedChangedEventDetail;
			savedChangeEventHandler({ ...newValue, sourceComponentId: 'storage' });
		}
	};
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	window.addEventListener(SAVED_CHANGED_EVENT, selfWindowHandler);
	window.addEventListener('storage', storageHandler);

	return () => {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		window.removeEventListener(SAVED_CHANGED_EVENT, selfWindowHandler);
		window.removeEventListener('storage', storageHandler);
	};
};

export const addSavedFetchedListener = (
	savedFetchedEventHandler: SavedFetchedEventHandler
): (() => void) => {
	const selfWindowHandler = (event: SavedFetchedEvent) => {
		savedFetchedEventHandler(event.detail);
	};
	const storageHandler = (event: StorageEvent) => {
		if (event.key === SAVED_FETCHED_EVENT) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			const newValue = JSON.parse(event.newValue) as SavedFetchedEventDetail;
			savedFetchedEventHandler({ ...newValue, sourceComponentId: 'storage' });
		}
	};
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	window.addEventListener(SAVED_FETCHED_EVENT, selfWindowHandler);
	window.addEventListener('storage', storageHandler);

	return () => {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		window.removeEventListener(SAVED_FETCHED_EVENT, selfWindowHandler);
		window.removeEventListener('storage', storageHandler);
	};
};

export const dispatchSavedChangedEvent = (
	saveUrl: string,
	newState: boolean,
	sourceComponentId?: string
) => {
	const eventDetail: SavedChangedEventDetail = {
		saveUrl,
		newState,
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		sourceComponentId,
	};
	localStorage.setItem(SAVED_CHANGED_EVENT, JSON.stringify(eventDetail));
	window.dispatchEvent(
		new CustomEvent(SAVED_CHANGED_EVENT, {
			detail: eventDetail,
		}) as SavedChangedEvent
	);
};

export const dispatchSavedFetchedEvent = (
	saveUrl: string,
	newState: boolean,
	sourceComponentId?: string,
	item?: SeriesItemData | null
) => {
	const eventDetail: SavedFetchedEventDetail = {
		saveUrl,
		newState,
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		item,
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		sourceComponentId,
	};
	localStorage.setItem(SAVED_FETCHED_EVENT, JSON.stringify(eventDetail));
	window.dispatchEvent(
		new CustomEvent(SAVED_FETCHED_EVENT, {
			detail: eventDetail,
		}) as SavedFetchedEvent
	);
};
